import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PartnerState } from '@interfaces/state_interfaces';

export const selectPartnerState = createFeatureSelector<PartnerState>('partner');

export const selectTotalPartners = createSelector(
    selectPartnerState,
    (state: PartnerState) => state.totalPartners
);

export const selectTotalActivePartners = createSelector(
    selectPartnerState,
    (state: PartnerState) => state.totalActivePartners
);

export const selectTotalInactivePartners = createSelector(
    selectPartnerState,
    (state: PartnerState) => state.totalInactivePartners
);

export const selectPartnerLoading = createSelector(
    selectPartnerState,
    (state: PartnerState) => state.loading
);

export const selectPartnerError = createSelector(
    selectPartnerState,
    (state: PartnerState) => state.error
); 